export default "__VITE_ASSET__Btt7oOlt__"